'use client';

import type { BlockRenderProps } from '../../types';
import { buildDirectContactActions } from './buildDirectContactActions';
import { ReservationChannelShell } from './ReservationChannelShell';

/**
 * Compat alias of direct contact (same shell as Messenger).
 * Existing Call projects keep rendering; picker hides this key for new picks.
 */
export function ReservationCallBook(props: BlockRenderProps) {
  const { actions, nextChromeKey } = buildDirectContactActions(
    props.block,
    props.locale,
    props.editable,
  );
  return (
    <ReservationChannelShell
      {...props}
      channel="direct"
      actions={actions}
      nextChromeKey={nextChromeKey}
    />
  );
}
